import { render, staticRenderFns } from "./JobAdmin.vue?vue&type=template&id=619d4cf5&scoped=true"
import script from "./JobAdmin.vue?vue&type=script&lang=js"
export * from "./JobAdmin.vue?vue&type=script&lang=js"
import style0 from "./JobAdmin.vue?vue&type=style&index=0&id=619d4cf5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d4cf5",
  null
  
)

export default component.exports